/**
 * シンプルなルーティング管理
 */
export class Router {
  private currentPath: string

  constructor() {
    this.currentPath = window.location.pathname
  }

  /**
   * 現在のパスを取得
   */
  getCurrentPath(): string {
    return this.currentPath
  }

  /**
   * ルートを解析
   */
  parseRoute(): RouteInfo {
    const path = this.currentPath

    // /sample/[id] - 特定のサンプル
    const sampleMatch = path.match(/^\/sample\/([^/]+)$/)
    if (sampleMatch) {
      return {
        type: 'sample',
        sampleId: sampleMatch[1],
        allowSampleSelection: false,
      }
    }

    // /samples - 全サンプル選択可能
    if (path === '/samples' || path === '/samples/') {
      return {
        type: 'samples',
        sampleId: null,
        allowSampleSelection: true,
      }
    }

    // / - デフォルト（空のエディタ）
    return {
      type: 'default',
      sampleId: null,
      allowSampleSelection: false,
    }
  }

  /**
   * デバッグモードかどうか
   */
  isDebugMode(): boolean {
    const params = new URLSearchParams(window.location.search)
    return params.get('debug') === 'true'
  }
}

export interface RouteInfo {
  type: 'default' | 'sample' | 'samples'
  sampleId: string | null
  allowSampleSelection: boolean
}